import { isProblemDetails, problemMessages, type ProblemDetails } from "@qorakul/shared/api";

/** Error thrown by mutations when the API answers with a non-success status; carries the problem details when present. */
export class ApiError extends Error {
  readonly problem: ProblemDetails | undefined;

  constructor(status: number, error: unknown) {
    super(String(status));
    this.problem = isProblemDetails(error) ? error : undefined;
  }
}

/** Human-readable lines for an error produced by a mutation. */
export function errorLines(err: unknown, fallback: string): string[] {
  return err instanceof ApiError ? problemMessages(err.problem, fallback) : [fallback];
}
